module.exports = __webpack_public_path__ + "img/browser.28ea59c6.png";